/**
 * All frontend scripts that can be in <head> should be included here.
 *
 * This is the file that Webpack is compiling into main-head.[hash].js
 */

import "./sass/inline.scss";
import "./sass/head.scss";

require("./js/utils/throttle");
